import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const { defineMultiStyleConfig: r, definePartsStyle: t } = e([
  "container",
  "leftElement",
  "rightElement",
  "divider"
]), n = t({
  container: {
    // V2 classes
    ".dual-input-left": {
      borderEndRadius: "none"
    },
    ".dual-input-left-control": {
      ".chakra-form__error-message": {
        display: "none"
      }
    },
    ".dual-input-right": {
      borderStartRadius: "none"
    },
    ".dual-input-right-control": {
      ".chakra-form__error-message": {
        display: "none"
      }
    }
  },
  // V1 classes
  leftElement: {
    ".dual-input-left": {
      borderEndRadius: "none"
    },
    ".dual-input-left-control": {
      ".chakra-form__error-message": {
        display: "none"
      }
    }
  },
  // V1 classes
  rightElement: {
    ".dual-input-right": {
      borderStartRadius: "none"
    },
    ".dual-input-right-control": {
      ".chakra-form__error-message": {
        display: "none"
      }
    }
  },
  divider: {
    color: "gray.200",
    height: "auto",
    border: "0px solid",
    borderWidth: "0 0 0 1px"
  }
}), a = r({
  baseStyle: n
});
export {
  a as default
};
